import { getIntegrationDetails } from 'components/Previews/getIntegrationDetails'
import Styles from './FacebookChrome.module.scss'
import { PlatformChromeProps } from './Types'
import { Avatar } from './Avatar'
import dayjs from 'dayjs'
import { useState } from 'react'
import { Earth } from 'components/Previews/FacebookPreview/icons'
import { Share, ThumbUp } from 'blaze-ui/icons'
import { FacebookComment } from 'blaze-ui/icons/16'

export const FacebookChrome = ({ children, integration, caption }: PlatformChromeProps) => {
  const [timestamp] = useState(() => dayjs())
  const { picture, username } = getIntegrationDetails(integration)

  return (
    <div className={Styles.chrome}>
      <div className={Styles.header}>
        <Avatar picture={picture} className={Styles.avatar} />
        <div className={Styles.accountInfo}>
          <div className={Styles.username}>{username}</div>
          <div className={Styles.postDate}>
            {timestamp.format('MMM D')} at {timestamp.format('HH:mm')} <Earth size={9} />
          </div>
        </div>
      </div>
      <div className={Styles.captionContainer}>
        <div className={Styles.caption} dangerouslySetInnerHTML={{ __html: caption || '' }} />
      </div>
      {children}
      <div className={Styles.footer}>
        <ThumbUp size={16} />
        <FacebookComment />
        <Share size={16} />
      </div>
    </div>
  )
}
